import { diagram } from '@diagram/state/diagram';
import { Helpers, SideEffect } from '@diagram/state/effects/diagram/helpers';

import { SyncEngineHelpers } from 'helpers/SyncEngineHelpers';

const syncTwoPortConverterPower: SideEffect = (change) => {
    const { type, data } = change;

    if (type === 'delete') return;

    for (const [path, value] of Object.entries(data)) {
        const match = Helpers.matchComponentInstance<{
            port: string;
            voltageType: 'AC' | 'DC';
        }>(path, /specifications\.electrical\.ports\.(?<port>\d+)\.(?<voltageType>AC|DC)\.power/);

        if (!match) {
            continue;
        }

        const { id, port, voltageType } = match;

        const componentInstance = diagram.componentInstances[id];

        if (!componentInstance) {
            // TODO Remove in the future.
            console.warn(`Couldn't find component instance ${id} in syncTwoPortConverterPower`, change);
        }

        if (
            componentInstance &&
            componentInstance.componentId === null &&
            componentInstance.componentType === 'converter' &&
            componentInstance.specifications.electrical.ports.length === 2 &&
            voltageType in componentInstance.specifications.electrical.ports[0] &&
            voltageType in componentInstance.specifications.electrical.ports[1]
        ) {
            const nextKey = {
                '0': Helpers.removePrefix(path).replace('ports.0', 'ports.1'),
                '1': Helpers.removePrefix(path).replace('ports.1', 'ports.0'),
            }[port];

            if (nextKey) {
                SyncEngineHelpers.set(componentInstance, nextKey, value);
            }
        }
    }
};

export { syncTwoPortConverterPower };
